import {Store} from 'redux';
import urls from 'urls';
import {setEventAttributes} from '~/common/event/eventAttributes/reducer';
import {EventAttributes} from '~/common/event/types';
import {selectEventId} from '~/common/fabric/EventGuests/reducers/guests/selectors';

export const fetchEventAttributes = async (store: Store) => {
  const eventId: string | undefined = selectEventId(store.getState());
  if (!eventId) return;

  try {
    const url = urls.get('ajax_get_event_attributes', {eventId});
    const resp = await evite.fetch(url, {
      method: 'get',
      credentials: 'include',
      headers: {Accept: 'application/json'},
    });
    const response = await resp.json();
    const attributes: EventAttributes = response ?? {};
    store.dispatch(setEventAttributes(attributes));
  } catch (err) {
    evite.error(`Error fetching event attributes for event ID ${eventId}:`, err);
  }
};
